/* */ 
'use strict';
var datasetKey = 'aaDataset';
var valueKey = 'aaValue';
var datumKey = 'aaDatum';
var _ = require('../common/utils');
var DOM = require('../common/dom');
var html = require('./html');
var css = require('./css');
var EventEmitter = require('./event_emitter');
function Dataset(o) {
  o = o || {};
  o.templates = o.templates || {};
  if (!o.source) {
    _.error('missing source');
  }
  if (o.name && !isValidName(o.name)) {
    _.error('invalid dataset name: ' + o.name);
  }
  this.query = null;
  this._isEmpty = true;
  this.highlight = !!o.highlight;
  this.name = typeof o.name === 'undefined' || o.name === null ? _.getUniqueId() : o.name;
  this.source = o.source;
  this.displayFn = getDisplayFn(o.display || o.displayKey);
  this.templates = getTemplates(o.templates, this.displayFn);
  this.css = _.mixin({}, css, o.appendTo ? css.appendTo : {});
  this.cssClasses = o.cssClasses = _.mixin({}, css.defaultClasses, o.cssClasses || {});
  this.cssClasses.prefix = o.cssClasses.formattedPrefix || _.formatPrefix(this.cssClasses.prefix, this.cssClasses.noPrefix);
  var clazz = _.className(this.cssClasses.prefix, this.cssClasses.dataset);
  this.$el = o.$menu && o.$menu.find(clazz + '-' + this.name).length > 0 ? DOM.element(o.$menu.find(clazz + '-' + this.name)[0]) : DOM.element(html.dataset.replace('%CLASS%', this.name).replace('%PREFIX%', this.cssClasses.prefix).replace('%DATASET%', this.cssClasses.dataset));
  this.$menu = o.$menu;
}
Dataset.extractDatasetName = function extractDatasetName(el) {
  return DOM.element(el).data(datasetKey);
};
Dataset.extractValue = function extractValue(el) {
  return DOM.element(el).data(valueKey);
};
Dataset.extractDatum = function extractDatum(el) {
  var datum = DOM.element(el).data(datumKey);
  if (typeof datum === 'string') {
    datum = JSON.parse(datum);
  }
  return datum;
};
_.mixin(Dataset.prototype, EventEmitter, {
  _render: function render(query, suggestions) {
    if (!this.$el) {
      return;
    }
    var that = this;
    var hasSuggestions;
    var renderArgs = [].slice.call(arguments, 2);
    this.$el.empty();
    hasSuggestions = suggestions && suggestions.length;
    this._isEmpty = !hasSuggestions;
    if (!hasSuggestions && this.templates.empty) {
      this.$el.html(getEmptyHtml.apply(this, renderArgs)).prepend(that.templates.header ? getHeaderHtml.apply(this, renderArgs) : null).append(that.templates.footer ? getFooterHtml.apply(this, renderArgs) : null);
    } else if (hasSuggestions) {
      this.$el.html(getSuggestionsHtml.apply(this, renderArgs)).prepend(that.templates.header ? getHeaderHtml.apply(this, renderArgs) : null).append(that.templates.footer ? getFooterHtml.apply(this, renderArgs) : null);
    }
    if (this.$menu) {
      this.$menu.addClass(this.cssClasses.prefix + (hasSuggestions ? 'with' : 'without') + '-' + this.name).removeClass(this.cssClasses.prefix + (hasSuggestions ? 'without' : 'with') + '-' + this.name);
    }
    this.trigger('rendered', query);
    function getEmptyHtml() {
      var args = [].slice.call(arguments, 0);
      args = [{
        query: query,
        isEmpty: true
      }].concat(args);
      return that.templates.empty.apply(this, args);
    }
    function getSuggestionsHtml() {
      var args = [].slice.call(arguments, 0);
      var $suggestions;
      var nodes;
      var self = this;
      var suggestionsHtml = html.suggestions.replace('%PREFIX%', this.cssClasses.prefix).replace('%SUGGESTIONS%', this.cssClasses.suggestions);
      $suggestions = DOM.element(suggestionsHtml).css(this.css.suggestions);
      nodes = _.map(suggestions, getSuggestionNode);
      $suggestions.append.apply($suggestions, nodes);
      return $suggestions;
      function getSuggestionNode(suggestion) {
        var $el;
        var suggestionHtml = html.suggestion.replace('%PREFIX%', self.cssClasses.prefix).replace('%SUGGESTION%', self.cssClasses.suggestion);
        $el = DOM.element(suggestionHtml).attr({
          role: 'option',
          id: ['option', Math.floor(Math.random() * 100000000)].join('-')
        }).append(that.templates.suggestion.apply(this, [suggestion].concat(args)));
        $el.data(datasetKey, that.name);
        $el.data(valueKey, that.displayFn(suggestion) || undefined);
        $el.data(datumKey, JSON.stringify(suggestion));
        $el.children().each(function() {
          DOM.element(this).css(self.css.suggestionChild);
        });
        return $el;
      }
    }
    function getHeaderHtml() {
      var args = [].slice.call(arguments, 0);
      args = [{
        query: query,
        isEmpty: !hasSuggestions
      }].concat(args);
      return that.templates.header.apply(this, args);
    }
    function getFooterHtml() {
      var args = [].slice.call(arguments, 0);
      args = [{
        query: query,
        isEmpty: !hasSuggestions
      }].concat(args);
      return that.templates.footer.apply(this, args);
    }
  },
  getRoot: function getRoot() {
    return this.$el;
  },
  update: function update(query) {
    var that = this;
    this.query = query;
    this.canceled = false;
    this.source(query, render);
    function render(suggestions) {
      if (!that.canceled && query === that.query) {
        var args = [].slice.call(arguments, 1);
        args = [query, suggestions].concat(args);
        that._render.apply(that, args);
      }
    }
  },
  cancel: function cancel() {
    this.canceled = true;
  },
  clear: function clear() {
    this.cancel();
    this.$el.empty();
    this.trigger('rendered', '');
  },
  isEmpty: function isEmpty() {
    return this._isEmpty;
  },
  destroy: function destroy() {
    this.$el = null;
  }
});
function getDisplayFn(display) {
  display = display || 'value';
  return _.isFunction(display) ? display : displayFn;
  function displayFn(obj) {
    return obj[display];
  }
}
function getTemplates(templates, displayFn) {
  return {
    empty: templates.empty && _.templatify(templates.empty),
    header: templates.header && _.templatify(templates.header),
    footer: templates.footer && _.templatify(templates.footer),
    suggestion: templates.suggestion || suggestionTemplate
  };
  function suggestionTemplate(context) {
    return '<p>' + displayFn(context) + '</p>';
  }
}
function isValidName(str) {
  return (/^[_a-zA-Z0-9-]+$/).test(str);
}
module.exports = Dataset;
